export default {
  ADD: "ADD",
  EDIT: "EDIT",
};
